/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Height_WordsInputs */

const en_us2_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`height cm tall`)
};

const pt_br2_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`altura cm estatura`)
};

const es_419_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estatura altura cm`)
};

const pt_pt2_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`altura cm estatura`)
};

const fr_fr2_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`taille cm hauteur grandeur`)
};

const de_de2_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`größe cm körpergröße groß`)
};

const it_it2_search_field_height_words = /** @type {(inputs: Search_Field_Height_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`altezza cm statura`)
};

/**
* | output |
* | --- |
* | "height cm tall" |
*
* @param {Search_Field_Height_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_height_words = /** @type {((inputs?: Search_Field_Height_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Height_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_height_words(inputs)
	if (locale === "es-419") return es_419_search_field_height_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_height_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_height_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_height_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_height_words(inputs)
	return en_us2_search_field_height_words(inputs)
});
export { search_field_height_words as "search.field_height_words" }